
const treatments = [
  {
    icon: 'ri-heart-pulse-line',
    title: '鍼治療',
    description: '経絡理論に基づいた繊細な施術で、体の内側から不調を改善します。肩こり、腰痛、頭痛、自律神経の不調など、様々な症状に対応。一人ひとりの体質に合わせた施術を行います。',
    bgColor: 'bg-sub',
  },
  {
    icon: 'ri-fire-line',
    title: 'お灸治療',
    description: '温熱効果で血行を促進し、冷え性や慢性的な疲労を改善します。心地よい温かさが体を癒し、免疫力の向上にも効果的です。',
    bgColor: 'bg-accent/20',
  },
  {
    icon: 'ri-sparkling-line',
    title: '美容鍼',
    description: '顔のツボを刺激し、リフトアップやシワ改善など、内側から美しさを引き出します。化粧品では届かない深部からのアプローチで、自然な若々しさを取り戻します。',
    bgColor: 'bg-primary/10',
  },
  {
    icon: 'ri-mental-health-line',
    title: '自律神経調整',
    description: 'ストレスや不規則な生活で乱れた自律神経を整えます。不眠、めまい、動悸などの症状改善に効果的です。',
    bgColor: 'bg-sub',
  },
  {
    icon: 'ri-run-line',
    title: 'スポーツ鍼灸',
    description: 'スポーツ障害の治療やパフォーマンス向上をサポート。アスリートの体調管理にも対応します。',
    bgColor: 'bg-accent/20',
  },
];

const TreatmentDetails = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center mb-12 sm:mb-16 md:mb-24">
          <div>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-gray-900 mb-4 sm:mb-6">
              <strong className="text-primary">診療内容</strong>
            </h2>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
              <strong>おかやま鍼灸院</strong>では、<strong>東洋医学の伝統的な理論</strong>と<strong>最新の医学知識</strong>を融合させた、幅広い施術を提供しています。<strong>岡山市北区</strong>で一人ひとりの症状や体質に合わせた<strong>オーダーメイドの鍼灸治療</strong>を行い、<strong>痛みの根本改善</strong>を目指します。
            </p>
            
            <div className="space-y-3 sm:space-y-4">
              {treatments.map((treatment, index) => (
                <article
                  key={index}
                  className={`${treatment.bgColor} rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:shadow-lg transition-all cursor-pointer group`}
                >
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white rounded-lg sm:rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform">
                      <i className={`${treatment.icon} text-xl sm:text-2xl text-primary`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-serif text-lg sm:text-xl text-gray-900 mb-1 sm:mb-2">{treatment.title}</h3>
                      <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">{treatment.description}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="h-96 sm:h-[600px] lg:h-[800px]">
            <img
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/443ed52f8f68b718a664aa9474473a91.jpeg"
              alt="鍼灸施術の様子"
              className="w-full h-full object-cover rounded-2xl sm:rounded-3xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentDetails;
